import React, { useState, useEffect } from "react";
import "./users.css";
import {
  Table,
  Tag,
  Space,
  Button,
  Input,
  Modal,
  Form,
  Upload,
  message,
  Avatar,
  Popconfirm,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
  UserOutlined,
  MailOutlined,
  LockOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import configureAppStore from "../../redux/store";

// const { Title } = Typography;

const Users = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [isloading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [form] = Form.useForm();
  const [previewVisible, setPreviewVisible] = useState(false);

  const handleRemove = () => {
    setPreview(null);
    form.setFieldValue("image", null);
  };
  const getAllUser = () => {
    let getRes = (res) => {
      console.log("res of user list", res);
      setUsers(res?.users);
    };

    callApi(
      "GET",
      `${routes.getAllAdmin}?role=admin`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      },
    );
  };
  const deleteUser = (id) => {
    let getRes = (res) => {
      getAllUser();
    };

    callApi(
      "DELETE",
      `${routes.userDelete}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      },
    );
  };

  useEffect(() => {
    getAllUser();
  }, []);
  const [search, setSearch] = useState("");

  // 🔍 Filtered users by search term
  const filteredData = users?.filter(
    (user) =>
      user.name.toLowerCase()?.includes(searchText.toLowerCase()) ||
      user.email.toLowerCase()?.includes(searchText.toLowerCase()),
  );

  // Form Submit

  const handleCreateUser = (values) => {
    console.log("values", values);
    let getRes = (res) => {
      if (res.status == 200) {
        message.success("User created successfully!");
        navigate("/");
        setIsModalOpen(false);
        form.resetFields();
        getAllUser();
      }
      message.error(res.message);

      // setUsers(res?.data?.data);
    };

    let body = {
      email: values.email,
      name: values.name,
      image: values.image,
      role: "admin",
      password: values.password,
      confirmPassword: values.confirm,
      device: {
        id: "3242fwefwe4324",
        deviceToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
      },
    };

    callApi("POST", routes.createAdmin, body, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });
  };

  const uploadImageToS3 = async (file) => {
    const myHeaders = new Headers();

    // Get token from redux store (same as callApi)
    const token = configureAppStore.getState().userDataSlice.token ?? false;
    if (token) {
      myHeaders.append("Authorization", token);
    }

    const formdata = new FormData();
    formdata.append("images", file);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      setIsLoading(true);
      const response = await fetch(routes.imageUpload, requestOptions);
      const res = await response.json();
      console.log("res of image upload", res);

      if (
        res?.status === 200 &&
        res?.success &&
        Array.isArray(res?.data) &&
        res.data.length > 0 &&
        res.data[0]?.Location
      ) {
        return res.data[0].Location;
      } else {
        const errorMessage = res?.message || "Image upload failed";
        message.error(errorMessage);
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("Image upload error:", error);
      message.error("Image upload failed");
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  const handleUpload = async (file) => {
    try {
      const url = await uploadImageToS3(file);
      form.setFieldValue("image", url); // ✅ set URL directly in form
      setPreview(url);
      message.success("Image uploaded successfully!");
    } catch (err) {
      console.error("Upload failed:", err);
      message.error("Upload failed!");
    }
  };
  const columns = [
    {
      title: "User",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          <Avatar src={record.image} icon={<UserOutlined />} />
          <span className="user-name-text">{text}</span>
        </Space>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role) => (
        <Tag color="blue" className="role-tag">
          {role.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "active" ? "green" : "red"}>
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title="Delete User"
          description={`Are you sure you want to delete ${record.name}?`}
          onConfirm={() => deleteUser(record.id)}
          okText="Yes"
          cancelText="No"
          okButtonProps={{ className: "delete-confirm-btn" }}
        >
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            className="delete-action-btn"
          >
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };
  return (
    <div className="user-management-container">
      <div className="table-header-actions">
        <Input
          placeholder="Search users..."
          prefix={<SearchOutlined />}
          className="search-input"
          onChange={(e) => setSearchText(e.target.value)}
        />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          className="add-user-btn"
          onClick={() => setIsModalOpen(true)}
        >
          Add New User
        </Button>
      </div>

      <Table
        loading={isloading}
        columns={columns}
        dataSource={users?.filter((u) =>
          u?.name?.toLowerCase()?.includes(searchText.toLowerCase()),
        )}
        rowKey="id"
        className="user-table"
        scroll={{ x: 700 }}
      />

      <Modal
        title="Create New User"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleCreateUser}>
          <Form.Item name="name" label="Full Name" rules={[{ required: true }]}>
            <Input
              placeholder="Enter your name"
              size="large"
              prefix={<UserOutlined />}
            />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input
              placeholder="Enter your email"
              size="large"
              prefix={<MailOutlined />}
            />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            placeholder="Enter password"
            rules={[
              { required: true, message: "Please enter your password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
            hasFeedback
          >
            <Input.Password
              placeholder="Enter password"
              size="large"
              prefix={<LockOutlined />}
            />
          </Form.Item>
          <Form.Item
            name="confirm"
            label="Confirm Password"
            dependencies={["password"]}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value)
                    return Promise.resolve();
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm password"
              size="large"
              prefix={<LockOutlined />}
            />
          </Form.Item>
          <Form.Item
            name="image"
            label="Profile Image"
            //rules={[{ required: true, message: "Please upload an image" }]}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              {preview ? (
                <div
                  style={{
                    position: "relative",
                    width: 120,
                    height: 120,
                    borderRadius: 8,
                    overflow: "hidden",
                    border: "2px solid #1890ff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    src={preview}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() => setPreviewVisible(true)} // 👈 open large preview
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      display: "flex",
                      gap: 6,
                    }}
                  >
                    <Button
                      size="small"
                      type="text"
                      shape="circle"
                      icon={<EyeOutlined />}
                      onClick={() => setPreviewVisible(true)}
                    />
                    <Button
                      size="small"
                      type="text"
                      shape="circle"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={handleRemove}
                    />
                  </div>
                </div>
              ) : (
                <Upload
                  showUploadList={false}
                  beforeUpload={(file) => {
                    handleUpload(file);
                    return false;
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload Image</Button>
                </Upload>
              )}
            </div>

            {/* 👇 Large image preview modal */}
            <Modal
              open={previewVisible}
              footer={null}
              onCancel={() => setPreviewVisible(false)}
              centered
            >
              <img
                alt="Preview"
                style={{
                  width: "100%",
                  borderRadius: 8,
                  maxHeight: "80vh",
                  objectFit: "cover",
                }}
                src={preview}
              />
            </Modal>
          </Form.Item>
          <Button
            loading={isloading}
            size="large"
            type="primary"
            htmlType="submit"
            className="submit-btn"
            block
          >
            Create User
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default Users;
